import React, { useEffect, useState } from "react";

// project-imports
import { CodeCompilerFirstRow } from "./CodeCompilerFirstRow";
import { CodeCompilerSecondRow } from "./CodeCompilerSecondRow";
import { CodeCompilerThirdRow } from "./CodeCompilerThirdRow";
import BreadcrumbOne from "../../common/breadcrumb/BreadcrumbOne";
import Layout from "../../common/Layout";
import { defineTheme } from "./defineTheme";
import "./compiler.css";
import NoSampleFound from "../error-message/NoSampleFound";

// // Reading environment variable start
// We will impliment in next version Start Commment 
// const JUDGE0_API_HOST = process.env.REACT_APP_JUDGE0_API_HOST;
// const JUDGE0_API_KEY = process.env.REACT_APP_JUDGE0_API_KEY;
// const JUDGE0_API_URL = process.env.REACT_APP_JUDGE0_API_URL;
// Reading environment variable end
// We will impliment in next version End Commment

function CodeCompilerContainer() {

    // State initialization
    //  state manage for setting the default language as per the selected course
    const [theme, setTheme] = useState("");
    const [customInput, setCustomInput] = useState("");
    const [outputDetails, setOutputDetails] = useState(null);
    const [selectedSampleCode, setSelectedSampleCode] = useState("");

    // const [processing, setProcessing] = useState(null);
    // const javascriptDefault = `// some comment`;
    // const [code, setCode] = useState(javascriptDefault);
    // const [defaultSelectedLanguage, setSelectedLanguage] = useState();

    // for passing sample code to code editor
    // let newCode = "";
    // let newOutput = "";
    // let newInput = "";

    // Constant functions
    const handleSampleChange = (sampleCode, outputDetails) => {
        setOutputDetails(outputDetails)
        setSelectedSampleCode(sampleCode);
    };

    // setting  language as per the course selcted
    // const handleLanguageChange = (sampleLanguage) => {
    //     setSelectedLanguage(sampleLanguage);
    // };

    //handling  theme 
    function handleThemeChange(th) {
        const theme = th;

        if (["light", "vs-dark"].includes(theme.value)) {
            setTheme(theme);
        } else {
            defineTheme(theme.value).then((_) => setTheme(theme));
        }
    }

    useEffect(() => {
        defineTheme("active4d").then((_) =>
            setTheme({ value: "active4d", label: "active4d" })
        );
    }, []);


    // for user selected langauge option

    // const onChange = (action, data) => {
    //     switch (action) {
    //         case "code": {
    //             setCode(data);
    //             break;
    //         }
    //         default: {
    //             console.warn("case not handled!", action, data);
    //         }
    //     }
    // };

    //code compile function  
    // const handleCompile = () => {

    //     setProcessing(true);
    //     const formData = {
    //         // encode source code in base64
    //         language_id: defaultSelectedLanguage,
    //         source_code: btoa(newCode),
    //         stdin: btoa(newInput),
    //     };

    //     const options = {
    //         method: "POST",
    //         url: JUDGE0_API_URL,
    //         params: { base64_encoded: "true", fields: "*" },
    //         headers: {
    //             "content-type": "application/json",
    //             "Content-Type": "application/json",
    //             "X-RapidAPI-Host": JUDGE0_API_HOST,
    //             "X-RapidAPI-Key": JUDGE0_API_KEY,
    //         },
    //         data: formData,
    //     };

    //     axios
    //         .request(options)
    //         .then(function (response) {
    //             console.log("res.data", response.data);
    //             const token = response.data.token;
    //             checkStatus(token);
    //         })
    //         .catch((err) => {
    //             let error = err.response ? err.response.data : err;
    //             setProcessing(false);
    //             console.log(error);
    //         });
    // };

    // //to get result of the code
    // const checkStatus = async (token) => {
    //     const options = {
    //         method: "GET",
    //         url: JUDGE0_API_URL + "/" + token,
    //         params: { base64_encoded: "true", fields: "*" },
    //         headers: {
    //             "X-RapidAPI-Host": JUDGE0_API_HOST,
    //             "X-RapidAPI-Key": JUDGE0_API_KEY,
    //         },
    //     };
    //     try {
    //         let response = await axios.request(options);
    //         let statusId = response.data.status?.id;

    //         // Processed - we have a result
    //         if (statusId === 1 || statusId === 2) {
    //             // still processing
    //             setTimeout(() => {
    //                 checkStatus(token)
    //             }, 2000)
    //             return
    //         } else {
    //             setProcessing(false)
    //             setOutputDetails(response.data)
    //             // showSuccessToast(`Compiled Successfully!`)
    //             console.log('response.data', response.data)
    //             return
    //         }
    //     } catch (err) {
    //         console.log("err", err);
    //         setProcessing(false);
    //         // showErrorToast();
    //     }
    // };


    return (
        <Layout footerVariant="variant-1">
            {/* header part start  */}
            <BreadcrumbOne
                title="Code Compiler"
                rootUrl="/"
                parentUrl="Home"
                currentUrl="Code Compiler"
            />
            {/* header part end  */}
            {/* first row start */}
            <div className="edu-course-area border border-1  pt--30 pl--30 pr--30">
                <CodeCompilerFirstRow onSampleChange={handleSampleChange}
                    handleThemeChange={handleThemeChange} customInput={customInput}
                    setCustomInput={setCustomInput} setOutputDetails={setOutputDetails}
                />
            </div>
            {/* first row end */}
            <div className="edu-course-area pl--30 pr--30 bg-color-white">
                <div className="container-fluid p-0">

                    {selectedSampleCode.length === 0 &&
                        <NoSampleFound />
                    }
                    {selectedSampleCode && selectedSampleCode.length &&
                        <div>
                            <div className="border border-1 border-bottom-0 bg-color-grey plr--10 pt--10 pb--10">
                                {/* second row start */}
                                <CodeCompilerSecondRow selectedSampleCode={selectedSampleCode} theme={theme} />
                                {/* second row end */}
                            </div>
                            <div className="border border-1 pt--30">
                                {/* third row start */}
                                <CodeCompilerThirdRow customInput={customInput} outputDetails={outputDetails} setOutputDetails={setOutputDetails} />
                                {/* third row end  */}
                            </div>
                        </div>
                    }
                </div>
            </div>
        </Layout>
    );
}

export default CodeCompilerContainer;
